import FollowUs from "./followUs";
import { useTheme } from "styled-components";
import { contacts } from "helpers/links-builders/contactUsFooterLinks";
import { classNames, labelHelper, trField } from "helpers/themeHelpers";
import useGetCountry from "hooks/useGetCountry";
import IconPhone from "assets/icons/IconPhone";
import IconEmail from "assets/icons/IconEmail";
import IconWhatsapp from "assets/icons/IconWhatsapp";
import IconSalesMan from "assets/icons/IconSalesMan";
import { FooterTwoDesktopCont } from "componentLayout/Footer/FooterTwo/FooterTwoDesktop/styled.styles";
const Icon1 = () => <IconEmail fill="#999" />;
const Icon2 = () => <IconPhone />;
const Icon3 = () => <IconWhatsapp />;
const Icon4 = () => <IconSalesMan />;

const FooterTwoDesktop = () => {
  const { locale, protocol, domain, translations } = useTheme();
  const countryData = useGetCountry();
  const icons = [<Icon1 />, <Icon2 />, <Icon3 />, <Icon4 />];
  return (
    <FooterTwoDesktopCont
      id="footerTwoDesktop"
      className="lightGrayBg pt-16 pb-16 overflowHidden relative flex alignItemsCenter"
    >
      <div className="flex width-1200 flexSpaceBetween m-auto">
        <div className="flex gap-15">
          {contacts(protocol, countryData, domain, translations).map(
            (contact, index) => (
              <a
                key={index}
                href={contact.href[locale].replace(/\s/g, "")}
                {...classNames("flex bold alignItems gap-10")}
              >
                <div className="contactUsIcon whiteBg fullRadius flex alignItems justifyContent">
                  {icons[index]}
                </div>
                <div>
                  <div className="blackColor mb-8">{labelHelper(contact)}</div>
                  <span className="ltr inline">
                    {trField(contact, "hrefLabel")}
                  </span>
                </div>
              </a>
            )
          )}
        </div>
        <FollowUs />
      </div>
    </FooterTwoDesktopCont>
  );
};

export default FooterTwoDesktop;
